import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, Typography, Chip, Tooltip,
  Table, TableBody, TableCell, TableHead, TableRow, IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import { listarModelos, excluirModelo, previaModelo } from "../../services/certificadoService";
import { instituicaoDe } from "../../config/instituicoes";

export default function CertificadoModeloList() {
  const navigate = useNavigate();
  const [modelos, setModelos] = useState([]);

  const carregar = async () => {
    try { setModelos((await listarModelos(true)).data); }
    catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };
  useEffect(() => { carregar(); }, []);

  const inativar = async (m) => {
    const r = await Swal.fire({
      title: "Inativar modelo?",
      text: m.Eventos > 0 ? `${m.Eventos} evento(s) usam este modelo e continuam funcionando.` : "",
      icon: "warning", showCancelButton: true, confirmButtonText: "Inativar", cancelButtonText: "Cancelar",
    });
    if (!r.isConfirmed) return;
    await excluirModelo(m.Id); carregar();
  };

  const ver = async (id) => {
    try { await previaModelo(id); }
    catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Box>
          <Typography variant="h5">Modelos de certificado</Typography>
          <Typography variant="body2" color="text.secondary">
            Arte, assinaturas e cidade ficam aqui — o evento só escolhe o modelo e informa carga horária, frequência e texto.
          </Typography>
        </Box>
        <Button variant="contained" onClick={() => navigate("/certificados/novo")}>Novo modelo</Button>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Instituição</TableCell>
              <TableCell>Cidade</TableCell>
              <TableCell>Assinaturas</TableCell>
              <TableCell align="center">Arte</TableCell>
              <TableCell align="center">Eventos</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modelos.map((m) => (
              <TableRow key={m.Id} hover sx={{ opacity: m.Ativo ? 1 : 0.5 }}>
                <TableCell>{m.Nome}</TableCell>
                <TableCell>{m.Instituicao ? instituicaoDe(m.Instituicao).nome : "—"}</TableCell>
                <TableCell>{m.Cidade || "—"}</TableCell>
                <TableCell>
                  {[m.Assinante1, m.Assinante2].filter(Boolean).join(" • ") || "—"}
                </TableCell>
                <TableCell align="center">
                  {m.TemFundo ? <Chip size="small" color="success" variant="outlined" label="com arte" />
                    : <Chip size="small" variant="outlined" label="sem arte" />}
                </TableCell>
                <TableCell align="center">{m.Eventos}</TableCell>
                <TableCell>{m.Ativo ? <Chip size="small" color="success" label="Ativo" /> : <Chip size="small" label="Inativo" />}</TableCell>
                <TableCell align="center">
                  <Tooltip title="Pré-visualizar"><IconButton size="small" onClick={() => ver(m.Id)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Editar"><IconButton size="small" onClick={() => navigate(`/certificados/${m.Id}`)}><EditIcon fontSize="small" /></IconButton></Tooltip>
                  {m.Ativo && (
                    <Tooltip title="Inativar"><IconButton size="small" color="error" onClick={() => inativar(m)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {modelos.length === 0 && (
              <TableRow><TableCell colSpan={8} align="center">Nenhum modelo cadastrado.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
